/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import { READ_PAYROLL_REPORT } from 'domain/finance/payroll/shared/payrollService';
import PayrollList from 'domain/finance/payroll/List';
import { ProtectedRouter } from 'infrastructure/routing';
import { getPayrollListUrl, getPayrollRouterPath, usePayrollRoute } from './route';
const PayrollRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = usePayrollRoute();

  return (
    <ProtectedRouter basePath={getPayrollListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PAYROLL_REPORT}>
              <PayrollList />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PayrollRouter.getRouterPath = getPayrollRouterPath;

export default PayrollRouter;
